<div class="w-100">
  <mwp-card-content-header [url]="apiUrl" />
  @if (!isEditing) {
    <div>
      @if (currentDirectDeposit) {
        <mwp-direct-deposit-form title="Current Direct Deposit" [directDeposit]="currentDirectDeposit"/>
      }
      @if (!currentDirectDeposit) {
        <div>
          <div class="message-container blue-fill text-centered mb-4">
            <mwp-text-translate text="No Direct Deposit" jsonKey="noDirectDeposit" />
          </div>
        </div>
      }
      <div class="d-flex justify-content-end mb-3">
        <button class="mwp-button" (click)="newDirectDeposit()">
          <mwp-text-translate text="New Direct Deposit" jsonKey="newDirectDeposit" />
        </button>
      </div>
    </div>
  }
  @if (isEditing) {
    <div>
      <mwp-direct-deposit-form title="New Direct Deposit" [isEditing]="isEditing" [directDeposit]="changeRequestDirectDeposit" (cancelEmit)="cancelEdit($event)"/>
    </div>
  }
</div>